/**
 * Layout constants shared by `CvPreview.vue` and the pagination helpers.
 *
 * These mirror the Tailwind gaps used in the CV template — keep them in sync
 * with the `gap-[…]` classes there, otherwise pagination measures a page the
 * renderer does not draw.
 */

/** `gap-[48px]` between two sections in the right column. */
export const CV_SECTION_GAP = 48

/** `gap-[24px]` between two entries inside a section. */
export const CV_ENTRY_GAP = 24

/** Sections that may be cut between entries and continued on the next page. */
export const CV_SPLITTABLE_BLOCK_TYPES = [
  'praktikum',
  'bildungsweg',
  'praktikum-cont',
  'bildungsweg-cont',
]
